import React, { useState, useRef } from 'react';
import './ScoreInChat.css';

const PlayIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" width="16" height="16" className={className} aria-hidden="true">
    <path d="M5 3v18l15-9L5 3z" fill="currentColor" />
  </svg>
);

const ChevronDown = ({ className }) => (
  <svg viewBox="0 0 24 24" width="14" height="14" className={className} aria-hidden="true">
    <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" fill="currentColor" />
  </svg>
);

const ChevronUp = ({ className }) => (
  <svg viewBox="0 0 24 24" width="14" height="14" className={className} aria-hidden="true">
    <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z" fill="currentColor" />
  </svg>
);

const ScoreInChat = ({ svgs, hash, id, onOpenInPlayer }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const containerRef = useRef(null);

  const handleCollapse = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0; // Reset scroll position
    }
    setIsExpanded(false);
  };

  if (!svgs || !hash) return null;

  const toggleExpand = () => {
    if (isExpanded) handleCollapse();
    else setIsExpanded(true);
  };

  return (
    <div className="score-in-chat">
      <button
        onClick={() => onOpenInPlayer(id)}
        className="open-player-button"
        title="Open in player"
        aria-label="Open in player"
      >
        <PlayIcon />
      </button>

      <button
        onClick={toggleExpand}
        className={`toggle-expand-button ${isExpanded ? 'expanded' : 'collapsed'}`}
        title={isExpanded ? 'Collapse score' : 'Expand score'}
        aria-label={isExpanded ? 'Collapse score' : 'Expand score'}
      >
        {isExpanded ? <ChevronUp /> : <ChevronDown />}
      </button>

      <div
        ref={containerRef}
        className={`score-svg-container ${isExpanded ? 'expanded' : 'collapsed'}`}
      >
        {svgs.map((svg, index) => (
          <div
            key={index}
            className="score-svg-page"
            dangerouslySetInnerHTML={{ __html: svg }}
          />
        ))}
      </div>
    </div>
  );
};

export default ScoreInChat;